import styles from './Top.module.scss'
import { Button } from '../components/Button'
import React from 'react'
import { Breadcrumb } from './components/Breadcrumb'

export type paths = { name: string; url: string }[]

type Props = {
  contents: {
    smallTitle: string
    title: string
    text: string
    imgLink: string
  }
  paths: paths
}

export const Top: React.FC<Props> = ({ contents, paths }) => {
  return (
    <div className={styles.top_container}>
      <div className={styles.main_container}>
        <div className={styles.top_contents}>
          <Breadcrumb paths={paths} />
          <div className={styles.title_wrapper}>
            <div className={styles.page_title}>
              <p className={styles.small_title}>{contents.smallTitle}</p>
              <p className={styles.title}>{contents.title}</p>
            </div>
            <p className={styles.shoulder_copy}>{contents.text}</p>
          </div>
          <div className={styles.button_wrapper}>
            <div className={styles.button_wrapper}>
              {/* <Button text="サービス資料をダウンロード" href="資料追加" /> */}
              <Button text="お問い合わせ" href="/contact" red="true" />
            </div>
          </div>
        </div>
        <img src={contents.imgLink} alt="" className={styles.top_image} />
      </div>
    </div>
  )
}
